import React, { Component } from 'react';
import styled from 'styled-components';

const ErrorWrapper = styled.div`
  padding: 2rem;
`;
interface State {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

class ErrorBoundary extends Component<{}, State> {
  constructor(props: any) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // todo: GA or coralogix FE error logging?
    console.error(error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    const { error, errorInfo } = this.state;
    if (error && errorInfo) {
      return (
        <ErrorWrapper>
          <h2>{`Uh oh, something's not right.`}</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {error.toString()}
            <br />
            {errorInfo.componentStack}
          </details>
        </ErrorWrapper>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
